import React from "react";
import ToolbarCommon from "./toolbar.common";
import { ApplicationContext } from "src/context";
import ToolbarLiveConditions from "src/modules/liveConditions/components/toolbar/toolbar.liveconditions";

export default class ToolbarV1 extends ToolbarCommon {
    /** context: ApplicationContext */
    static contextType = ApplicationContext;
    /** @ts-ignore */
    context!: React.ContextType<typeof ApplicationContext>;

    private toolbarRef = React.createRef<HTMLDivElement>();

    componentDidMount() {
        super.componentDidMount?.();
        this.updateHeight();
    }

    componentDidUpdate(prevProps: any) {
        // Recalculate height if scrolled state changes (height can change between 40px and 56px)
        if (prevProps.scrolledDown !== this.props.scrolledDown) {
            this.updateHeight();
        }
    }

    updateHeight = () => {
        if (!this.toolbarRef.current || !this.context?.setHeaderHeight) return;
        
        // Use requestAnimationFrame to ensure DOM is fully rendered
        requestAnimationFrame(() => {
            const element = this.toolbarRef.current;
            if (element) {
                const height = element.offsetHeight || 0;
                this.context.setHeaderHeight('toolbar', height);
            }
        });
    }

    get full_width() {
        return this.props.toolbar.full_width;
    }

    get fullwidthClassname(){
        if (this.full_width) return "";
        return "max-w-7xl";
    }

    get alignment() {
        const { alignment } = this.props.toolbar;
        if (alignment === "center") return "justify-center";
        return "justify-end"
    }


    public get style(): any {
        const {toolbar} = this.props;
        return {
            '--text-color': toolbar.text_color?.value,
            '--hover-color': toolbar.hover_color?.value,
            '--background': toolbar.background_color?.value,

            '--dropdown-background': toolbar.dropdown_menu_background_color?.value || '#fff',
            '--dropdown-active-color': toolbar.text_color?.value,
            '--dropdown-text-color': toolbar.unselected_item_color?.value,
            '--dropdown-hover-color': toolbar.hover_color?.value,
        }
    }

    public render() {
        const heightClass = this.props.scrolledDown ? 'h-[40px]' : 'h-[56px]';

        return (
        <>
            {this.renderChangeStoreDisclaimer()}
            <div ref={this.toolbarRef} id="toolbar" className={`hidden lg:flex sticky w-full top-0 z-[101] px-6 lg:px-10 toolbar flex-row ${heightClass} bg-[color:var(--background)] ${this.shadow}`} style={this.style}>
                <div className={`mx-auto w-full ${this.fullwidthClassname} flex flex-row items-center ${this.alignment} relative gap-6`}>
                    {this.props.toolbar.items.map((item, index) => this.renderToolbarItem(item, index))}
                    {this.props.toolbar.bars_live_conditions && (
                        <ToolbarLiveConditions
                            bars_live_conditions={this.props.toolbar.bars_live_conditions}
                            language={this.props.language}
                            defaultLanguage={this.props.defaultLanguage}
                        />
                    )}
                    {this.renderLanguagePicker()}
                    {this.renderCurrencyPicker()}
                    {this.renderMyAccount()}
                    {this.renderCart()}
                </div>
            </div>
        </>
        )
    }
}